export default "__VITE_ASSET__BuzeS_Il__"